module.exports = __webpack_public_path__ + "fonts/148a674.eot";